<template>
  <div class = "ProductSelect">
    <div class="PageHeader">
      <h2 class="PageHeader__subheading">{{$t("gsProductSelectHeading")}}</h2>
    </div>
    <div class="Selection">
      <button v-for="product in filteredProducts"  class="Selection__item" :key="product.id" v-on:click="selectProduct(product)"><span>{{product.name}}</span></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GSIssueSelect',
  data: function() {
    return {
      parent: this.$parent,
      filteredProducts: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      let state = this.$parent.getState();
      if (state.region === undefined) {
        console.log('No region selected.  Redirecting to guest services home');
        this.$router.push('/guest-services')
      } else {
        const productsByRegion = [...new Set(this.$parent.config.Sites.filter(site => {
          return site.region === state.region.id;
        }).map(site => site.products
          .split(',').filter(value => value.trim() !== ''))
          .filter(productArray => productArray.length !== 0)
          .reduce((accumulator, currentValue) => accumulator.concat(currentValue))
          .map(entry => entry.trim()))];

        this.filteredProducts = this.$parent.config.Products.filter(product => {
          return product.filter_sites === 'FALSE' || productsByRegion.includes(product.id);
        });
      }
    })
  },
  methods: {
    selectProduct(product) {
      this.parent.state.product = product.id;
      this.$router.push({
        path: '/guest-services/siteSelect'
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GuestServices/GSProductSelect.vue